import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";
import { toast } from "sonner";
import { activateWaiting, scheduleUpdateChecks, watchForNewVersion, showReloadToast } from "@/lib/swUpdate";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// RU-PREVIEWGATE2 (PG2-4): a new deploy reaches open tabs — the waiting worker takes over, and the tab
// shows a "New version available — Reload" toast (never an automatic reload).
if ("serviceWorker" in navigator) {
  watchForNewVersion(navigator.serviceWorker, () => showReloadToast(toast));
}
serviceWorkerRegistration.register({
  onUpdate: activateWaiting,
  onRegistered: (registration) => scheduleUpdateChecks(registration),
});
